import { VirtualJoystick } from "@babylonjs/core/Misc/virtualJoystick"


export default class TouchJoysticks {

    constructor() {

        this.RIGHT_STICK = createRightStick();

        this.LEFT_STICK = createLeftStick();

        this.R_BUTTON = null

        this.L_BUTTON = null;


        function createRightStick() {

            const rightStick = new VirtualJoystick(false);
            rightStick.setActionOnTouch(() => {
                console.log("touched!");
            });

            return rightStick;

        }

        function createLeftStick() {

            const leftStick = new VirtualJoystick(true);
            leftStick.setJoystickColor("white");

            return leftStick;

        }
    }
}